import Container from '../../GlobalComponents/Container';
import Flex from '../../GlobalComponents/Flex';

export const AccessibilityIcon = () => (
	<Flex $flexDirection="column" $alignItems="center" $justifyContent="center">
		<Container width={'1140'}>
			<iframe
				src="https://portal.audioeye.com/accessibility-statement.html?siteHash=9a670a583bfd9b40996411ae257928c9"
				title="Accessibility Statement"
				style={{
					width: '100%',
					maxWidth: '900px',
					height: '2400px',
					border: 'none',
					overflow: 'hidden'
				}}
				frameBorder="0"
				scrolling="no"
			></iframe>

			<style>
				{`
        @media (max-width: 768px) {
          iframe {
            max-width: 100vw !important; /* full width on mobile */
			height: 3800px !important; /* full height on mobile */
          }
        }
      `}
			</style>
		</Container>
	</Flex>
);
